import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../../auth/AuthContext';
import { IssuancesIndexPage } from './IssuancesIndexPage';

/**
 * `/inventory/issuances` — the module's landing, which is its FIRST tab the reader may see.
 *
 * The sidebar entry is a CONTAINER of two lists now, gated on either key, so a reader holding
 * only `issuances.read-requests` is sent on to Requests rather than bounced off a route their
 * own rail just offered them. The route above it still gates on the pair.
 */
export function IssuancesRoute() {
  const { hasPermission } = useAuth();

  return hasPermission('issuances.read') ? (
    <IssuancesIndexPage />
  ) : (
    <Navigate to="/inventory/issuances/requests" replace />
  );
}
